import React, { Component, useState, Fragment } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import Switch from 'react-bootstrap/Switch';


export default class StaffTonyaModal extends Component{
    state={
          isOpen: false
    }
  
    constructor(props) {
      super(props);
      this.state = { 
				checked: true,
			};
    }
  
    componentDidMount () {
    }
  
  
    openModal = () => this.setState({ isOpen: true });
    closeModal = () => this.setState({ isOpen: false });
  
  
    handleChange = (e) => {
			console.dir(e);
      this.setState({ checked: !this.state.checked });

			this.props.data.howmany_staff_tonya = this.props.data.howmany_staff_tonya - 1;
			this.props.changeStaffTonya(this.props.data.howmany_staff_tonya);
    }
  
    render(){
			console.log(this.props.data.howmany_staff_tonya);

			const content = this.props.data.staff_tonya_array.map((tonya, index) =>
				<div key={index} className="col-6">
          <Switch
            id={"switch_"+index} 
            label={tonya}
            checked={this.state.checked}
            onChange={this.handleChange}
          />
				</div>
			);

      return (
        <>
          <i className="bi-card-list px-1 mx-1 bg-dark text-white"  onClick={this.openModal}></i>
  
          <Modal show={this.state.isOpen} onHide={this.closeModal} className="modal-dialog modal-lg">
            <Modal.Header closeButton>
              <Modal.Title>担当する問屋さんリスト</Modal.Title>
            </Modal.Header>
            <Modal.Body>

							<div className="container">
							  <div className="row">
									{content}
							  </div>
							</div>

								

            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={this.closeModal}>Close</Button>
            </Modal.Footer>
          </Modal>
        </>
      );
    }
  }
  
  

	//{...this.props}